(function () {
  function initGallery(gallery) {
    if (!gallery || gallery.dataset.galleryInit === 'true') return;
    gallery.dataset.galleryInit = 'true';

    const mainImage = gallery.querySelector('.product-gallery-new__image');
    if (!mainImage) return;

    const thumbnails = Array.from(gallery.querySelectorAll('.product-gallery-new__thumbnail'));
    if (!thumbnails.length) return;

    const thumbnailRail = gallery.querySelector('.product-gallery-new__thumbnails');
    const prevButton = gallery.querySelector('.product-gallery-new__nav--prev');
    const nextButton = gallery.querySelector('.product-gallery-new__nav--next');

    mainImage.setAttribute('decoding', 'async');

    // Preload the other high-res variants so arrow clicks are instant — but only
    // AFTER the hero image has loaded and the browser is idle. Firing these on
    // init flooded the network and starved the above-the-fold hero, leaving a
    // blank gray box on first paint (mobile especially).
    function preloadRest() {
      thumbnails.forEach(function (thumb) {
        if (thumb.classList.contains('is-active')) return; // hero is already loading
        const imageUrl = thumb.getAttribute('data-image-url');
        const imageSrcset = thumb.getAttribute('data-image-srcset');
        if (!imageUrl) return;
        const pre = new Image();
        if (imageSrcset) pre.srcset = imageSrcset;
        pre.src = imageUrl;
      });
    }

    function schedulePreload() {
      const idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); };
      idle(preloadRest);
    }

    if (mainImage.complete) {
      schedulePreload();
    } else {
      mainImage.addEventListener('load', schedulePreload, { once: true });
      mainImage.addEventListener('error', schedulePreload, { once: true });
    }

    let switching = false;

    function setActive(index) {
      const target = thumbnails[index];
      if (!target || switching) return;

      const imageUrl = target.getAttribute('data-image-url');
      const imageSrcset = target.getAttribute('data-image-srcset');
      const imageAlt = target.getAttribute('data-image-alt');
      const imageWidth = target.getAttribute('data-image-width');
      const imageHeight = target.getAttribute('data-image-height');
      if (!imageUrl) return;

      // Update active state immediately so the UI responds even before the
      // image swap completes.
      thumbnails.forEach(function (t) { t.classList.remove('is-active'); });
      target.classList.add('is-active');
      if (thumbnailRail) {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      // Decode the next image off-screen before swapping. Falls back to a
      // plain src swap on browsers without HTMLImageElement.decode().
      switching = true;
      const next = new Image();
      if (imageSrcset) next.srcset = imageSrcset;
      next.src = imageUrl;

      const swap = function () {
        mainImage.src = imageUrl;
        if (imageSrcset) mainImage.srcset = imageSrcset;
        if (imageAlt) mainImage.alt = imageAlt;
        if (imageWidth) mainImage.width = imageWidth;
        if (imageHeight) mainImage.height = imageHeight;
        switching = false;
      };

      if (typeof next.decode === 'function') {
        next.decode().then(swap).catch(swap);
      } else if (next.complete) {
        swap();
      } else {
        next.addEventListener('load', swap, { once: true });
        next.addEventListener('error', swap, { once: true });
      }
    }

    function getActiveIndex() {
      const i = thumbnails.findIndex(function (t) { return t.classList.contains('is-active'); });
      return i === -1 ? 0 : i;
    }

    thumbnails.forEach(function (thumbnail, index) {
      thumbnail.addEventListener('click', function (e) {
        e.preventDefault();
        setActive(index);
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function (e) {
        e.preventDefault();
        const i = getActiveIndex();
        setActive((i - 1 + thumbnails.length) % thumbnails.length);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (e) {
        e.preventDefault();
        const i = getActiveIndex();
        setActive((i + 1) % thumbnails.length);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.product-gallery-new').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
